var timestamp = new Date().getTime();
//小田急　イメージ
var img_odakyu = 'https://hakone:97ls3IzI@ohh.jcld.jp/OHH_EXT/product/opimg/operation.png?' + timestamp;
//伊豆箱　イメージ
var img_oizuhako = 'https://hdmo.jcld.jp/HDM_EXT/product/opimg/operation.png?' + timestamp;


//++++++ 小田急 JSON ++++++++
// TOP
var json_odakyu_top = '../cmn/js/json/json_odakyu_top.php';
// GROUP
var json_odakyu_group = '../cmn/js/json/json_odakyu_group.php';
// ALL
var json_odakyu_all = '../cmn/js/json/json_odakyu_all.php';

//++++++ 小田急 配列 +++++++
var odakyu_top_array = [];
var odakyu_group_array = [];
var odakyu_all_array = [];

var odaku_rosen_array = {
	T0001: '箱根登山電車',
	T0002: '箱根登山ケーブルカー',
	T0003: '箱根ロープウェイ',
	T0004: '箱根海賊船',
	T0005: '箱根登山バス',
	//T0006:'小田急箱根高速バス',
	T0006: '小田急ハイウェイバス',
	T0007: 'ロマンスカー',
	T0008: '東海バス'
};

var izuhako_rosen_array = {
	T0201: '伊豆箱根バス',
	T0202: '箱根駒ヶ岳ロープウェー',
	T0203: '芦ノ湖遊覧船'
};






//++++++ 伊豆箱根 JSON ++++++++
// GROUP
var json_izuhako_group = '../cmn/js/json/json_izuhako_group.php';
// ALL
var json_izuhako_all = '../cmn/js/json/json_izuhako_all.php';

//++++++ 伊豆箱根  配列 +++++++
var izuhako_all_array = [];
var izuhako_group_array = [];


var TABLET_WIDTH = 768;
//ウィンドウ幅
var window_width = window.innerWidth;



$(function () {

	//CSS カスタムプロパティーに　innerHeigh を設定
	var height = window.innerHeight;
	document.documentElement.style.setProperty('--innerheight', height / 100 + 'px');

	$(window).resize(function () {
		var height = window.innerHeight;
		document.documentElement.style.setProperty('--innerheight', height / 100 + 'px');
	});


	// SP マップ画像を右端までスクロール
	$('.bus_map').scrollLeft(3000);



	//++++++ TAB クリック +++++
	$('.js_tab_item').on('click', function () {
		$('.bus_map').scrollLeft(3000);

		var data_tab = $(this).attr('data-tab');

		// TAB アクティブ設定
		$('.js_tab_item').removeClass('active');
		$(this).addClass('active');

		if (data_tab == 'odakyu') {
			// MAP画像切替
			$('#map_odakyu').fadeIn('fast');
			$('#map_izuhako').hide();

			// テキスト情報表示
			if (window_width >= TABLET_WIDTH) {
				$('.map_saide_odakyu').fadeIn('fast');
				$('.map_saide_izuhako').hide();
			} else {
				// スマホ調整
				if ($('.inner_col2_side2').hasClass('side2_ovelay')) {
					$('.map_saide_odakyu').fadeIn('fast');
					$('.map_saide_izuhako').hide();
				}
			}

			// TABカラー変更
			$('.map_tab_wrap').removeClass('tab_border_izuhako');
			$('.sp_info_btn').addClass('sp_info_btn_odakyu');
			$('.sp_info_btn').removeClass('sp_info_btn_izuhako');

		} else {
			// MAP画像切替
			$('#map_izuhako').fadeIn('fast');
			$('#map_odakyu').hide();

			// テキスト情報表示
			if (window_width >= TABLET_WIDTH) {
				$('.map_saide_izuhako').fadeIn('fast');
				$('.map_saide_odakyu').hide();
			} else {
				// スマホ調整
				if ($('.inner_col2_side2').hasClass('side2_ovelay')) {
					$('.map_saide_izuhako').fadeIn('fast');
					$('.map_saide_odakyu').hide();
				}
			}

			// TABカラー変更
			$('.map_tab_wrap').addClass('tab_border_izuhako');
			$('.sp_info_btn').addClass('sp_info_btn_izuhako');
			$('.sp_info_btn').removeClass('sp_info_btn_odakyu');
		}

	});

	//++++++ SP info BTN +++++
	$('.sp_info_btn').on('click', function () {

		if ($('.tab_odakyu').hasClass('active')) {
			$('.map_saide_odakyu').fadeIn('fast');
		} else {
			$('.map_saide_izuhako').fadeIn('fast');
		}

		$(this).hide();
		$('.inner_col2_side2').addClass('side2_ovelay');
		$('.sp_map_side_close').show();

	});

	//++++++ SP info CLOSE BTN +++++

	$('.sp_map_side_close').on('click', function () {
		$(this).hide();
		$('.bus_map_side').fadeOut('fast');
		$('.inner_col2_side2').removeClass('side2_ovelay');

		if ($('.tab_odakyu').hasClass('active')) {

			$('.sp_info_btn').fadeIn('fast');
			$('.sp_info_btn').addClass('sp_info_btn_odakyu');
			$('.sp_info_btn').removeClass('sp_info_btn_izuhako');

		} else {
			$('.sp_info_btn').fadeIn('fast');
			$('.sp_info_btn').addClass('sp_info_btn_izuhako');
			$('.sp_info_btn').removClass('sp_info_btn_odakyu');
		}

	});



	//+++++++ 小田急　グループ JSON読み込み +++++++++
	$.ajax({
			url: json_odakyu_group,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var json_length = Object.keys(data).length;

				var view_html = '<h3 class="bus_map_side_mid color_red">遅延・運転休止</h3>';
				view_html += '<dl class="bus_map_info">';
				var counter = 0;

				for (var i = 0; i < json_length; i++) {


					var group_cd = data[i].group_cd;
					var group_name = data[i].group_name;
					var group_comment = data[i].group_comment;

					// ** を <strong>に変換
					group_comment = group_comment.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
					// \r\n を<br>に変換
					group_comment = group_comment.replace(/\r?\n/g, '<br>');

					var group_comment_merge = data[i].group_comment_merge;

					// ** を <strong>に変換
					group_comment_merge = group_comment_merge.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
					// \r\n を<br>に変換
					group_comment_merge = group_comment_merge.replace(/\r?\n/g, '<br>');

					//平常でない場合配列に追加
					if (group_comment_merge) {
						odakyu_group_array.push(group_cd);

						view_html += '<dt>' + group_name + '</dt>';
						view_html += '<dd>' + group_comment_merge + '</dd>';
						counter++;

					}

				} //END for

				view_html += '</dl>';

				if (counter > 0) {
					$('.js-odakyu-top').html(view_html);
				}




			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 小田急　グループ


	//+++++++ 小田急　通常 JSON読み込み +++++++++
	$.ajax({
			url: json_odakyu_all,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var json_length = Object.keys(data).length;

				var active_array = [];
				var suspend_array = [];
				var end_array = [];


				for (var i = 0; i < json_length; i++) {

					var group_cd = data[i].group_cd;
					var group_name = data[i].group_name;
					var operation_flg = data[i].operation_flg;
					if (operation_flg == '03') {
						end_array.push(group_cd);
					}

				} //END for

				var flag_txt_0 = '平常通り運行中';
				var flag_txt_3 = '本日の運行は終了しております';


				var view_html = '<h3 class="bus_map_side_mid color_green">通常</h3>';
				view_html += '<dl class="bus_map_info">';
				var counter = 0;

				for (var key in odaku_rosen_array) {

					if ($.inArray(key, odakyu_group_array) > -1) {} else {
						if ($.inArray(key, end_array) > -1) {
							view_html += '<dt>' + odaku_rosen_array[key] + '</dt>';
							view_html += '<dd>' + flag_txt_3 + '</dd>';
							counter++;
						} else {
							view_html += '<dt>' + odaku_rosen_array[key] + '</dt>';
							view_html += '<dd>' + flag_txt_0 + '</dd>';
							counter++;
						}
					}



				} //END for

				view_html += '</dl>';

				if (counter > 0) {
					$('.js-odakyu-all').html(view_html);
				}




			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax　小田急　通常



	//+++++++ 伊豆箱根　グループ JSON読み込み +++++++++
	$.ajax({
			url: json_izuhako_group,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var json_length = Object.keys(data).length;

				var view_html = '<h3 class="bus_map_side_mid color_red">遅延・運転休止</h3>';
				view_html += '<dl class="bus_map_info">';
				var counter = 0;

				for (var i = 0; i < json_length; i++) {


					var group_cd = data[i].group_cd;
					var group_name = data[i].group_name;
					var group_comment = data[i].group_comment;

					// ** を <strong>に変換
					group_comment = group_comment.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
					// \r\n を<br>に変換
					group_comment = group_comment.replace(/\r?\n/g, '<br>');

					var group_comment_merge = data[i].group_comment_merge;
					// ** を <strong>に変換
					group_comment_merge = group_comment_merge.replace(/^\*\*(.*?)\*\*/g, '<strong>$1</strong>');
					// \r\n を<br>に変換
					group_comment_merge = group_comment_merge.replace(/\r?\n/g, '<br>');

					//平常でない場合配列に追加
					if (group_comment_merge) {
						izuhako_group_array.push(group_cd);

						view_html += '<dt>' + group_name + '</dt>';
						view_html += '<dd>' + group_comment_merge + '</dd>';
						counter++;

					}

				} //END for

				view_html += '</dl>';

				if (counter > 0) {
					$('.js-izuhako-top').html(view_html);
				}



			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax 小田急　グループ




	//+++++++ 伊豆箱　通常 JSON読み込み +++++++++
	$.ajax({
			url: json_odakyu_all,
			cache: false,
			dataType: 'json'
		})
		.then(
			function (data) {


				var json_length = Object.keys(data).length;

				var active_array = [];
				var suspend_array = [];
				var end_array = [];


				for (var i = 0; i < json_length; i++) {

					var group_cd = data[i].group_cd;
					var group_name = data[i].group_name;
					var operation_flg = data[i].operation_flg;
					if (operation_flg == '03') {
						end_array.push(group_cd);
					}

				} //END for

				var flag_txt_0 = '平常通り運行中';
				var flag_txt_3 = '本日の運行は終了しております';


				var view_html = '<h3 class="bus_map_side_mid color_green">通常</h3>';
				view_html += '<dl class="bus_map_info">';
				var counter = 0;

				for (var key in izuhako_rosen_array) {

					if ($.inArray(key, izuhako_group_array) > -1) {} else {
						if ($.inArray(key, end_array) > -1) {
							view_html += '<dt>' + izuhako_rosen_array[key] + '</dt>';
							view_html += '<dd>' + flag_txt_3 + '</dd>';
							counter++;
						} else {
							view_html += '<dt>' + izuhako_rosen_array[key] + '</dt>';
							view_html += '<dd>' + flag_txt_0 + '</dd>';
							counter++;
						}
					}



				} //END for

				view_html += '</dl>';

				if (counter > 0) {
					$('.js-izuhako-all').html(view_html);
				}




			},
			function () {
				console.log("読み込み失敗");

			}); //END Ajax　伊豆箱　通常





});